import { render, staticRenderFns } from "./checkbox-facet.vue?vue&type=template&id=125188d2&"
import script from "./checkbox-facet.vue?vue&type=script&setup=true&lang=js&"
export * from "./checkbox-facet.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./checkbox-facet.vue?vue&type=style&index=0&id=125188d2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports